import { render } from "./matching-badge-list.vue?vue&type=template&id=c0c35c06&scoped=true&ts=true"
import script from "./matching-badge-list.vue?vue&type=script&lang=ts"
export * from "./matching-badge-list.vue?vue&type=script&lang=ts"

import "./matching-badge-list.vue?vue&type=style&index=0&id=c0c35c06&lang=scss&scoped=true"
import "./matching-badge-list.vue?vue&type=style&index=1&id=c0c35c06&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0c35c06"]])

export default __exports__